"use client";

import { BeClassLogo } from "./BeClassLogo";
import type { BoxProps } from "@chakra-ui/react";

interface AppLogoProps extends Omit<BoxProps, "as"> {
  h?: string | number;
  w?: string | number;
}

export const AppLogo = ({ h = "45px", w = "auto", ...boxProps }: AppLogoProps) => {
  return (
    <BeClassLogo
      h={h}
      w={w}
      objectFit="contain"
      objectPosition="left center"
      {...boxProps}
    />
  );
};
